// Detail produktu — entry point (bundluje se do js/dist/product.min.js).
// Komponenty společné pro layout (mobilní menu v headeru, formuláře, video).
import '../components/header.js';
import '../components/homepage-video.js';
import '../components/forms.js';
import '../components/content-gallery.js';

// Lightbox jen pro obrázky z obsahu (.blog-image). Hlavní galerie produktu
// (.product-gallery) je záměrně bez lightboxu — jsou to čisté obrázky bez odkazu.
// GLightbox je globál z vendor bundle.
document.addEventListener('DOMContentLoaded', () => {
    if (typeof GLightbox === 'undefined') return;
    if (document.querySelector('.blog-image')) {
        GLightbox({ selector: '.blog-image', loop: true, touchNavigation: true });
    }
});
